import { DialogTitle } from '@mui/material';
import styled from 'styled-components';
import pallet from '../../../layouts/pallet';

export const DialogModalTitle = styled(DialogTitle).attrs({
  variant: 'h3'
})(() => ({
  margin: 0,
  padding: 2,
  backgroundColor: pallet.grayBackground
}));
